import * as React from 'react';
import autobind from 'autobind-decorator';
import { resolve } from 'inversify-react';
import { observable } from 'mobx';
import { observer } from 'mobx-react';

import { ToastNotifications } from 'src/core/ui/toast';
import { ObjectUtils } from 'src/core/utils/object';
import { HttpService } from 'src/core/services/http.service';
import { CardController } from 'src/app/shared/card.controller';
import { ProductServiceTypeListView } from './product-service-type-list.view';
import { ProductServiceTypeDataService } from './product-service-type-list.data';

interface ProductServiceTypeListProps {
	mode: ControlMode;
	onModeChanged: (mode: ControlMode) => void;
	setBusy(isBusy: boolean);
	contextService: any;
	category: ProductCategoryItem;
	defaultLanguage: string;
}

interface ProductServiceTypeListState {
	features?: { item1: string, item2: string }[];
}

@observer
export class ProductServiceTypeListController extends React.Component<ProductServiceTypeListProps, ProductServiceTypeListState> {
	@observable
	private dataService: ProductServiceTypeDataService;

	public state: ProductServiceTypeListState = {};

	@resolve
	private http: HttpService;

	@resolve
	private toast: ToastNotifications;
	constructor(props: Readonly<ProductServiceTypeListProps>) {
		super(props);
		this.state = {
			features: []
		};
	}
	public componentDidMount() {
		this.dataService = ProductServiceTypeDataService.make(this.props.contextService, false);
		if (this.props.category.id > 0) {
			this.loadData();
			this.loadFeatures();
		}
	}

	public render() {
		const model = this.dataService;
		const { features } = this.state;

		if (model == null || features == null) {
			return null;
		}

		return (
			<CardController
				icon="book"
				className="card-borderless"
				title="Services"
				mode={this.props.mode}>
				<ProductServiceTypeListView
					defaultLanguage={this.props.defaultLanguage}
					mode={this.props.mode}
					onModeChanged={this.props.onModeChanged}
					model={this.dataService}
					category={this.props.category}
					setBusy={this.props.setBusy}
					features={features}
				/>
			</CardController>
		);
	}

	@autobind
	private async loadData() {
		this.props.setBusy(true);
		this.dataService.addFilter('isDeleted', 'eq', false);
		this.dataService.addSorting('id', 'asc', true);
		const categoryId = this.props.category.id;
		if (categoryId && categoryId > 0) {
			this.dataService.addFilter('categoryId', 'eq', categoryId);
		}

		try {
			await this.dataService.load(query => query);
		} catch (error) {
			this.toast.showToast('Request failed', ObjectUtils.parseError(error), 'error');
		} finally {
			this.props.setBusy(false);
		}
	}

	private async loadFeatures() {
		try {
			this.props.setBusy(true);
			const response = await this.http.get(`api/v1/products/features?type=${this.props.category.productType}`);
			this.setState({
				features: response.data,
			});
		} catch (error) {
			this.toast.showToast('Request failed', ObjectUtils.parseError(error), 'error');
		} finally {
			this.props.setBusy(false);
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/products/product-service-types/list/product-service-type-list.controller.tsx